import type { PlanCode, PlanEntitlement } from '../types';

/**
 * Resolves the first paid tier which grants a capability from one catalog
 * snapshot. Keeping this independent from transport/cache code ensures a
 * paywall cannot recommend a different tier than the server just authorised
 * against.
 */
const PAID_PLAN_ORDER = ['lite', 'pro', 'max'] as const;

type PaidPlanCode = (typeof PAID_PLAN_ORDER)[number];
type PlanCatalog = ReadonlyMap<PlanCode, PlanEntitlement> | Partial<Record<PlanCode, PlanEntitlement>>;

export function lowestPaidPlanWithCapability(
	catalog: PlanCatalog,
	capability: 'githubDeepDive',
): PaidPlanCode | null {
	for (const code of PAID_PLAN_ORDER) {
		const entitlement = catalog instanceof Map
			? catalog.get(code)
			: (catalog as Partial<Record<PlanCode, PlanEntitlement>>)[code];
		if (entitlement?.[capability] === true) return code;
	}
	return null;
}
